<div class="row py-3 pr-2">
  <div class="col-3 text-center">
    <img src="assets/svg/ico-building-with-black-circle.svg" class="icon" />
  </div>
  <div class="col-6 heading">
    <app-with-tooltip [showHelpCursor]="false">{{ name }}</app-with-tooltip>
  </div>
  <div class="col-3 px-2 text-right setting-icon">
    <img src="assets/svg/ico-chevron-forward-outline.svg" />
  </div>
</div>
